import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchFaqsSchema } from '../../../services/faqs-schema';

const getFaqsSchema = (
  options: {
    locale: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchFaqsSchema>
] => [
  ['faqsSchema', { ...options }],
  ({ queryKey: [, key] }: { queryKey: [string, { locale: string }] }) =>
    fetchFaqsSchema(key, req),
];

export default getFaqsSchema;
